import { useCallback } from "react";

import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import styled from "styled-components";

import { PaymentMethod } from "@sso/constant";
import { CheckoutCreateRequest, Order } from "@sso/types";

interface StripePaymentProps {
  order: Order;
  clientId: string;
  token: string;
}

const Container = styled.div`
  width: 65%;
  height: 100%;
`;

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY!);
const StripePayment = ({ order, clientId, token }: StripePaymentProps) => {
  const fetchClientSecret = useCallback(() => {
    const postData: CheckoutCreateRequest = {
      orderId: order.id,
      paymentMethod: PaymentMethod.CARD,
    };
    const headers: HeadersInit = {
      "Content-Type": "application/json",
      "X-ClientId": clientId || "",
    };

    if (token) {
      headers["X-Security-Token"] = token;
    }

    return fetch(`${process.env.REACT_APP_BASE_URL}/sso/Checkout`, {
      method: "POST",
      body: JSON.stringify(postData),
      headers: headers,
    })
      .then(res => res.json())
      .then(data => {
        return data.result;
      });
  }, []);

  const options = { fetchClientSecret };

  return (
    <Container id="checkout">
      <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
        <EmbeddedCheckout />
      </EmbeddedCheckoutProvider>
    </Container>
  );
};

export default StripePayment;
